module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8003.3f1b38e7.png";